// CSV-Export der Nachweiskette (Chef-Sicht). Nutzt die geteilten CSV-Helfer (DE-Semikolon, CRLF, BOM) +
// den GETEILTEN Formel-Injection-Guard aus export/csv.ts: die `detail`-Spalte kann Chef-FREITEXT enthalten
// (Storno-/Korrektur-Gründe) — ohne Guard würde Excel eine mit =/+/-/@ beginnende Zelle als Formel ausführen.
// Uhrzeit MIT Sekunden: das Beweis-CSV muss Aktionen derselben Minute unterscheiden können.
import { localDayKey, parseDbTimestamp, type AuditEntryDTO } from '@wf/shared'
import { buildCsv, guardFormulaCell as guard } from '../export/csv'
import { formatWallClockSec } from '../time/format'
import { actionLabel } from './actionLabels'

/** Anzeigename des Akteurs: Name → nackte ID (anonymisiert/gelöscht, R9) → System/extern (z. B. Kunden-Freigabe). */
export function actorLabel(e: Pick<AuditEntryDTO, 'actorName' | 'actorUserId'>): string {
  if (e.actorName) return e.actorName
  if (e.actorUserId != null) return `Nutzer #${e.actorUserId}`
  return 'System/extern'
}

export function auditCsv(entries: readonly AuditEntryDTO[]): string {
  const headers = ['Datum', 'Uhrzeit', 'Aktion', 'Aktions-Code', 'Akteur', 'Ziel-Typ', 'Ziel-ID', 'Detail']
  const rows = entries.map((e) => {
    const ms = parseDbTimestamp(e.ts)
    return [
      localDayKey(ms),
      formatWallClockSec(ms),
      actionLabel(e.action),
      e.action,
      actorLabel(e),
      e.targetType ?? '',
      e.targetId ?? '',
      e.detail ?? '',
    ].map(guard)
  })
  return buildCsv(headers, rows)
}
